module.exports = __webpack_public_path__ + "static/media/undraw_file_searching_duff.12b750b7.svg";